import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import ImageLoader from '@starbucks-web/pattern-library/lib/components/image-loader';
import ExternalLink from '@starbucks-web/pattern-library/lib/components/external-link';

import H1 from 'shared/app/components/h1';
import StarbucksRewardsTrademark from 'shared/app/components/starbucks-rewards-trademark';
import {
  configImagesUrlSelector,
  marriottJoinLinkSelector,
} from 'shared/app/state/selectors/config';
import { rewardsMessages } from 'shared/app/messages/rewards';

import messages from './messages';
import JoinRewardsCta from './join-rewards-cta';

export const MarriottHeader = ({ isMarriottUnlinking }) => {
  const { formatMessage } = useIntl();
  const imageUrl = useSelector(configImagesUrlSelector);
  const marriottJoinLink = useSelector(marriottJoinLinkSelector);

  return (
    <React.Fragment>
      <ImageLoader
        alt={formatMessage(rewardsMessages.rewardsPartnershipsMarriott)}
        className="text-center"
        includeFallback={{
          enabled: true,
          fallbackClassName: 'bg-white',
        }}
        lazyLoad={{ enabled: false }}
        src={`${imageUrl}/rewards/loyalty-partnerships/marriott-bonvoy/partnership-logo.svg`}
        width={'277px'}
        wrapInFlex={{
          enabled: true,
          width: 277,
          height: 91,
          constrainWidth: true,
          flexEmbedWrapperClassName: 'mx-auto mb3',
        }}
      />
      <H1 className="text-bold text-center mb2" size="lg">
        {isMarriottUnlinking ? (
          <FormattedMessage {...messages.marriottUnlinkingHeader} />
        ) : (
          <FormattedMessage {...messages.marriottLinkingHeader} />
        )}
      </H1>
      <div className="pt2">
        {isMarriottUnlinking ? (
          <p className="text-center">
            <FormattedMessage {...messages.marriottUnlinkingBody} />
          </p>
        ) : (
          <React.Fragment>
            <p className="md-text-center mb2">
              <FormattedMessage
                {...messages.marriottLinkingBody}
                values={{ sbuxRewardsTm: <StarbucksRewardsTrademark /> }}
              />
            </p>
            <p className="md-text-center mb3">
              <FormattedMessage
                {...rewardsMessages.joinMarriottRewards}
                values={{
                  cta: (content) => (
                    <ExternalLink className="text-bold" href={marriottJoinLink}>
                      {content}
                    </ExternalLink>
                  ),
                }}
              />
            </p>
          </React.Fragment>
        )}
        {isMarriottUnlinking ? null : <JoinRewardsCta />}
      </div>
    </React.Fragment>
  );
};

export default MarriottHeader;
